import Hotjar from '@hotjar/browser'

Hotjar.init(process.env.HOTJAR_TOKEN, process.env.HOTJAR_VERSION) // will use env when deploying to production
